import { render } from "./ConfirmMetadata.vue?vue&type=template&id=67eaa356&scoped=true&ts=true"
import script from "./ConfirmMetadata.vue?vue&type=script&lang=ts"
export * from "./ConfirmMetadata.vue?vue&type=script&lang=ts"

import "./ConfirmMetadata.vue?vue&type=style&index=0&id=67eaa356&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67eaa356"]])

export default __exports__